import { isArray, isObject } from "lodash";
import moment from "moment";

export const formatTickets = (data) => {
  if (!data) {
    return [];
  }
  if (isArray(data)) {
    return data.map((data) => ({
      ...data,
      label: `${data.title || data.name || 'Sin título'}`,
      value: data._id,
    }));
  }
  if (isObject(data)) {
    return {
      ...data,
      value: data._id,
      label: `${data.title || data.name || 'Sin título'}`,
    };
  }
};
export const formatApplications = (data) => {
  if (!data) {
    return [];
  }
  if (isArray(data)) {
    return data.map((data) => ({
      ...data,
      label: `${data.name}`,
      value: data._id,
    }));
  }
  if (isObject(data)) {
    return {
      ...data,
      value: data._id,
      label: `${data.name}`,
    };
  }
};
export const formatUsers = (data) => {
  if (!data) {
    return [];
  }
  if (isArray(data)) {
    return data.map((data) => ({
      ...data,
      label: `${data.name} ${data.surname}`,
      value: data._id
    }));
  }
  if (isObject(data)) {
    return {
      ...data,
      value: data._id,
      label: `${data.name} ${data.surname}`
    };
  }
};

export const formatAlerts = (data) => {
  if (!data) {
    return [];
  }
  if (isArray(data)) {
    return data.map((data) => ({
      ...data,
      label: `${data.title}`,
      value: data._id,
    }));
  }
  if (isObject(data)) {
    return {
      ...data,
      value: data._id,
      label: `${data.title}`,
    };
  }
};

export const formatImputHours = (data) => {
	if (!data) {
		return [];
	}
	if (isArray(data)) {
		return data.map((data) => ({
			...data,
			label: `${data.name}`,
			value: data._id,
			end: data.end && moment(data.end),
			start: data.start && moment(data.start),
		}));
	}
	if (isObject(data)) {
		return {
			...data,
			value: data._id,
			label: `${data.name}`,
			end: data.end && moment(data.end),
			start: data.start && moment(data.start),
		};
	}
};

export const formatProjects = (data) => {
	if (!data) {
		return [];
	}
	if (isArray(data)) {
		return data.map((data) => ({
			...data,
			label: `${data.Description}`,
			value: data.No,
		}));
	}
	if (isObject(data)) {
		return {
			...data,
			value: data.No,
			label: `${data.Description}`,
		};
	}
};